import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';



const Deltas = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main" className='Common_warrent deltas_sec'>
                <div id="maintable" style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav" className='delta_table'>
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}}>Previous Topic</div>
                                            <div className="prevname " style={{textAlign: 'left'}}>Useful Warrant terms</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Useful Warrant terms</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Delta</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Exercise Ratio</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                            {/*<link rel="stylesheet" href="css/common.css"/>*/}
                            <title>Delta</title>
                            <style dangerouslySetInnerHTML={{__html: "\n            .contentbox table{\n                margin: 0 auto;\n            }\n            .contentbox table.ruletable tbody td{\n               height:3em;\n               width:30%;\n               color:#000000;\n            }\n            .contentbox table.ruletable tbody td.col1{\n                background-color: #FFF4D2;\n                text-align:left;\n                padding-left: 1em;\n            }\n            .contentbox table.ruletable tbody td.col2{\n                background-color: #FFFF80;\n                text-align:center;\n            }\n            .contentbox table.ruletable tbody td.col3{\n                background-color: #FFD400;\n                text-align:center;\n            }\n            .contentbox table.ruletable tfoot td.disclaimer{\n                padding-top: 0.5em;\n                color: #FFFFFF;\n                font-size: 0.8em;\n            }\n            .formulabox table td{\n/*                font-size: 1em;*/\n            }\n        " }} />
                            <div className="contentbox">
                                <p>Delta shows the approximate change in the warrant price for a small change in the underlying share (or asset) price.</p>
                                <div className="formulaholder">
                                <div className="formulabox">
                                    <div className="leqt">
                                    <table cellSpacing={0} cellPadding={0}>
                                        <tbody>
                                        <tr>
                                            <td style={{height: '41px'}}>    
                                            <span className="hltxt">Delta =</span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>   
                                    <div className="reqt">
                                    <table className="fraction" cellSpacing={0} cellPadding={0}>
                                        <tbody>
                                        <tr><td>Change in Warrant price</td></tr>
                                        <tr><td className="upper_line">Change in underlying share price</td></tr>
                                        </tbody>  
                                    </table>
                                    </div>
                                </div>
                                </div>
                                <p>Therefore, a delta of 50% means that the warrant should move approximately MYR 0.005 for each MYR 0.01 move in the underlying asset. Deltas for puts are negative since they move inversely with the underlying price.</p>
                                <table className="ruletable ctable">
                                <thead>
                                    <tr><td className="title" colSpan={3}>General rule of thumb for delta</td></tr>   
                                </thead>     
                                <tbody>
                                    <tr>
                                    <td />
                                    <td className="col2 htxt">Call</td>
                                    <td className="col3 htxt">Put</td>
                                    </tr>
                                    <tr>
                                    <td className="col1 htxt">In-the-money(max)</td>
                                    <td className="col2">100%</td>
                                    <td className="col3">-100%</td>
                                    </tr>
                                    <tr>
                                    <td className="col1 htxt">At-the-money</td>
                                    <td className="col2">50%</td>
                                    <td className="col3">-50%</td>
                                    </tr>
                                    <tr>
                                    <td className="col1 htxt">Out-of-the-money(min)</td>
                                    <td className="col2"><b>0%</b></td>
                                    <td className="col3"><b>0%</b></td>
                                    </tr>
                                </tbody>
                                </table>
                                <p>         
                                Deltas range from 0 to 100% for calls and 0 to -100% for puts
                                </p>
                                <div className="tipholder">
                                <div className="tipbox">
                                    <h2>Helpful tips on how to use Delta </h2>
                                    <ul>
                                    <li><p>Delta can also be viewed an indicator of the probability that a warrant will expire in the money (ie. with value). For example a warrant with a delta of 20% has a 20% probability that it will expire with value, and 80% chance that it will expire worthless.</p></li>
                                    <li><p>When using delta to estimate how much a warrant price will move for a particular price change in the underlying, you must take into consideration the warrants per share number to estimate the “delta per warrant”. See an <Link to="/edu/useful-warrant-terms/warrant-sensitivity" target="_blank">example</Link>  of how you can use delta and warrants per share to calculate a warrant’s sensitivity.</p></li>
                                    <li><p>Use caution when choosing warrants that have deltas either above 80% (termed deep in the money, ITM) or below 20% (termed deep out of the money, OTM) as issuers will often widen the offer spread for these warrants to discourage further buying in these warrants. Deep OTM warrants in particular, are risky for investors to buy.</p></li>
                                    <li><p>Macquarie provides delta for all warrants listed on the Bursa Malaysia, you view these via the <Link target="_blank" to="/tools/warrantsearch">Warrant Search Tool</Link> or the <Link target="_blank" to="/tools/warrantterms">Warrant Terms</Link> page</p></li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                  <div className='copyright_sec'>
                    Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                  </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            > <Link to="/edu/useful-warrant-terms/excercise-ratio">
                                    Exercise Ratio
                                </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/useful-warrant-terms/excercise-ratio">
                            <div className="next right" />
                        </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/useful-warrant-terms">
                            <div className="prev left" />
                        </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            >
                                <Link to="/edu/useful-warrant-terms">
                                  Useful Warrant terms
                                  </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
            {/* <div className="dbtn dbtn-seminarbtn">
            <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
      );
}
export default Deltas;